<mat-card class="page-card">
  <section class="page-header">
    <div class="page-header-content">
      <div class="page-header-icon">
        <mat-icon>business</mat-icon>
      </div>
      <div class="page-header-text">

        <h1>{{ 'dataManagement.organizationSettings.page.title' | transloco }}</h1>
        <p>{{ 'dataManagement.organizationSettings.page.description' | transloco }}</p>
      </div>
    </div>
    <div class="page-header-illustration" aria-hidden="true">
      <div class="illustration-card main"><mat-icon>inventory_2</mat-icon></div>
      <div class="illustration-card small top"><mat-icon>verified</mat-icon></div>
      <div class="illustration-card small bottom"><mat-icon>description</mat-icon></div>
    </div>
  </section>

  <mat-card-content>
    <!-- Allgemeine Daten -->
    <section class="content-section">
      <div class="section-header">
        <div>
          <span class="section-kicker">{{ 'dataManagement.organizationSettings.sections.generalData' | transloco }}</span>
          <h2>{{ 'dataManagement.organizationSettings.sections.organizationStatus' | transloco }}</h2>
        </div>
      </div>
      <div class="info-grid">
        <div class="status-card">
          <span class="field-label">{{ 'dataManagement.organizationSettings.fields.status' | transloco }}</span>
          <span class="status-tag active">
            <span class="status-dot"></span>
            {{ 'dataManagement.organizationSettings.fields.active' | transloco }}
          </span>
        </div>
        <div class="org-id-card">
          <div>
            <span class="field-label">{{ 'dataManagement.organizationSettings.fields.organizationId' | transloco }}</span>
            <strong>{{ organization.id }}</strong>
          </div>
          <mat-icon>lock</mat-icon>
        </div>
        <div class="org-id-card">
          <div>
            <span class="field-label">{{ 'friendRequests.addInviteDialog.organizationCode' | transloco }}</span>
            <strong>{{ organizationCode }}</strong>
          </div>
          <mat-icon>lock</mat-icon>
        </div>
      </div>
    </section>

    <!-- Stammdaten -->
    <section class="content-section">
      <div class="section-header">
        <div>
          <span class="section-kicker">{{ 'dataManagement.organizationSettings.sections.masterData' | transloco }}</span>
          <h2>{{ 'dataManagement.organizationSettings.sections.companyData' | transloco }}</h2>
        </div>
      </div>

      <div class="form-grid" [formGroup]="organizationForm">
        <div class="readonly-info-field span-12">
          <div class="readonly-content">
            <span class="field-label">{{ 'dataManagement.organizationSettings.fields.companyName' | transloco }}</span>
            <strong>{{ organization.name }}</strong>
          </div>
          <mat-icon>lock</mat-icon>
        </div>

        <mat-form-field appearance="outline" class="span-12" subscriptSizing="dynamic">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.streetAndHouseNumber' | transloco }}</mat-label>
          <input matInput formControlName="address" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="span-3" subscriptSizing="dynamic">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.postalCode' | transloco }}</mat-label>
          <input matInput formControlName="postCode" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="span-6" subscriptSizing="dynamic">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.city' | transloco }}</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="span-3" subscriptSizing="dynamic">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.country' | transloco }}</mat-label>
          <mat-select formControlName="location">
            <mat-option *ngFor="let country of allCountries" [value]="country.futureId">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="selfManufacturer" appearance="outline" class="span-12" subscriptSizing="dynamic">
          <mat-label>{{ 'createDoc.createDocDialog.docProfileLabel' | transloco }}</mat-label>
          <mat-select [value]="selfDefaultDocProfileId" (selectionChange)="setSelfDefaultDocProfileId($event.value)">
            <mat-option [value]="noDocProfileId">{{ 'createDoc.createDocDialog.docProfileNone' | transloco }}</mat-option>
            <mat-option *ngFor="let profile of docProfiles" [value]="profile.id">{{ profile.profileName }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <!-- PPWR Informationen -->
    <section class="content-section">
      <div class="section-header ppwr-header">
        <div>
          <span class="section-kicker">{{ 'dataManagement.organizationSettings.sections.ppwrInformation' | transloco }}</span>
          <h2>{{ 'dataManagement.organizationSettings.sections.rolesAndParticipants' | transloco }}</h2>
          <p>{{ 'dataManagement.organizationSettings.descriptions.ppwrRoles' | transloco }}</p>
        </div>
        <div class="info-callout">
          <mat-icon>tips_and_updates</mat-icon>
          <span>{{ 'dataManagement.organizationSettings.descriptions.tip' | transloco }}</span>
        </div>
      </div>

      <div class="role-grid">
        <!-- Manufacturer -->
        <article class="role-card">
          <div class="role-card-header">
            <div>
              <mat-icon>factory</mat-icon>
              <h3 [matBadge]="manufacturers.length" [matBadgeColor]="manufacturers.length >= maxEntriesPerRole ? 'warn' : 'primary'" matBadgeOverlap="false">
                {{ 'createDoc.createDocDialog.producerLabel' | transloco }}
              </h3>
            </div>
            <mat-form-field appearance="outline" class="role-search" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>
              <input
                matInput
                [formControl]="manufacturerSearchControl"
                [placeholder]="'common.buttons.search' | transloco"
                [attr.aria-label]="'common.buttons.search' | transloco" />
            </mat-form-field>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="manufacturers.length >= maxEntriesPerRole"
              (click)="openManufacturerDialog()">
              <mat-icon>add</mat-icon>{{ 'common.buttons.add' | transloco }}
            </button>
          </div>
          <div class="role-list">
            <p class="empty-text" *ngIf="manufacturers.length === 0">
              {{ 'dataManagement.organizationSettings.emptyStates.manufacturers' | transloco }}
            </p>
            <p class="empty-text" *ngIf="manufacturers.length > 0 && filteredManufacturers.length === 0">
              {{ 'common.text.noResults' | transloco }}
            </p>
            <div class="role-item" *ngFor="let item of filteredManufacturers" [class.readonly]="item === selfManufacturer">
              <div>
                <strong>{{ item.companyName }}</strong>
                <span>{{ item.address }} {{ item.postCode }} {{ item.city }}</span>
              </div>
              <mat-icon *ngIf="item === selfManufacturer" class="role-state">verified</mat-icon>
              <div class="item-actions" *ngIf="item !== selfManufacturer">
                <button mat-icon-button color="primary" type="button" [attr.aria-label]="'common.buttons.edit' | transloco" (click)="editManufacturer(manufacturers.indexOf(item))">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.deleteManufacturer' | transloco"
                  (click)="deleteManufacturer(manufacturers.indexOf(item))">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </article>

        <!-- Authorized Representative -->
        <article class="role-card">
          <div class="role-card-header">
            <div>
              <mat-icon>assignment_ind</mat-icon>
              <h3 [matBadge]="authorizedRepresentatives.length" [matBadgeColor]="authorizedRepresentatives.length >= maxEntriesPerRole ? 'warn' : 'primary'" matBadgeOverlap="false">
                {{ 'createDoc.createDocDialog.representativeTitle' | transloco }}
              </h3>
            </div>
            <mat-form-field appearance="outline" class="role-search" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>
              <input
                matInput
                [formControl]="representativeSearchControl"
                [placeholder]="'common.buttons.search' | transloco"
                [attr.aria-label]="'common.buttons.search' | transloco" />
            </mat-form-field>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="authorizedRepresentatives.length >= maxEntriesPerRole"
              (click)="openAuthorizedRepresentativeDialog()">
              <mat-icon>add</mat-icon>{{ 'common.buttons.add' | transloco }}
            </button>
          </div>
          <p class="role-description">
            {{ 'dataManagement.organizationSettings.descriptions.authorizedRepresentative' | transloco }}
          </p>
          <div class="role-list">
            <p class="empty-text" *ngIf="authorizedRepresentatives.length === 0">
              {{ 'dataManagement.organizationSettings.emptyStates.authorizedRepresentatives' | transloco }}
            </p>
            <p class="empty-text" *ngIf="authorizedRepresentatives.length > 0 && filteredAuthorizedRepresentatives.length === 0">
              {{ 'common.text.noResults' | transloco }}
            </p>
            <div class="role-item" *ngFor="let item of filteredAuthorizedRepresentatives">
              <div>
                <strong>{{ item.companyName }}</strong>
                <span>{{ item.address }} {{ item.postCode }} {{ item.city }}</span>
              </div>
              <div class="item-actions">
                <button
                  mat-icon-button
                  color="primary"
                  type="button"
                  [attr.aria-label]="'common.buttons.edit' | transloco"
                  (click)="editAuthorizedRepresentative(authorizedRepresentatives.indexOf(item))">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.deleteAuthorizedRepresentative' | transloco"
                  (click)="deleteAuthorizedRepresentative(authorizedRepresentatives.indexOf(item))">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </article>

        <!-- CEO -->
        <article class="role-card">
          <div class="role-card-header">
            <div>
              <mat-icon>supervisor_account</mat-icon>
              <h3 [matBadge]="ceos.length" [matBadgeColor]="ceos.length >= maxEntriesPerRole ? 'warn' : 'primary'" matBadgeOverlap="false">
                {{ 'createDoc.signersDialog.managingDirectorLabel' | transloco }}
              </h3>
            </div>
            <mat-form-field appearance="outline" class="role-search" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>
              <input
                matInput
                [formControl]="ceoSearchControl"
                [placeholder]="'common.buttons.search' | transloco"
                [attr.aria-label]="'common.buttons.search' | transloco" />
            </mat-form-field>
            <button mat-stroked-button color="primary" type="button" [disabled]="ceos.length >= maxEntriesPerRole" (click)="openCeoDialog()">
              <mat-icon>add</mat-icon>{{ 'common.buttons.add' | transloco }}
            </button>
          </div>
          <div class="role-list">
            <p class="empty-text" *ngIf="ceos.length === 0">
              {{ 'dataManagement.organizationSettings.emptyStates.ceos' | transloco }}
            </p>
            <p class="empty-text" *ngIf="ceos.length > 0 && filteredCeos.length === 0">
              {{ 'common.text.noResults' | transloco }}
            </p>
            <div class="role-item" *ngFor="let item of filteredCeos">
              <div>
                <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                <span>{{ item.email }}</span>
              </div>
              <div class="item-actions">
                <span class="status-tag" [class.active]="item.signatureImageId" [class.neutral]="!item.signatureImageId">
                  <span class="status-dot" [class.neutral]="!item.signatureImageId"></span>
                  {{ (item.signatureImageId ? 'dataManagement.organizationSettings.fields.signaturePresent' : 'dataManagement.organizationSettings.fields.noSignature') | transloco }}
                </span>
                <button
                  mat-icon-button
                  color="primary"
                  *ngIf="item.personProfileId > 0"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.editSignature' | transloco"
                  (click)="openSignatureDialog(item)">
                  <mat-icon>draw</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="primary"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.editCeo' | transloco"
                  (click)="editCeo(ceos.indexOf(item))">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.deleteCeo' | transloco"
                  (click)="deleteCeo(ceos.indexOf(item))">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </article>

        <!-- Signee -->
        <article class="role-card">
          <div class="role-card-header">
            <div>
              <mat-icon>draw</mat-icon>
              <h3 [matBadge]="signees.length" [matBadgeColor]="signees.length >= maxEntriesPerRole ? 'warn' : 'primary'" matBadgeOverlap="false">
                {{ 'createDoc.signersDialog.otherSignerTitle' | transloco }}
              </h3>
            </div>
            <mat-form-field appearance="outline" class="role-search" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>
              <input
                matInput
                [formControl]="signeeSearchControl"
                [placeholder]="'common.buttons.search' | transloco"
                [attr.aria-label]="'common.buttons.search' | transloco" />
            </mat-form-field>
            <button mat-stroked-button color="primary" type="button" [disabled]="signees.length >= maxEntriesPerRole" (click)="openSigneeDialog()">
              <mat-icon>add</mat-icon>{{ 'common.buttons.add' | transloco }}
            </button>
          </div>
          <div class="role-list">
            <p class="empty-text" *ngIf="signees.length === 0">
              {{ 'dataManagement.organizationSettings.emptyStates.signees' | transloco }}
            </p>
            <p class="empty-text" *ngIf="signees.length > 0 && filteredSignees.length === 0">
              {{ 'common.text.noResults' | transloco }}
            </p>
            <div class="role-item" *ngFor="let item of filteredSignees">
              <div>
                <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                <span>{{ item.function || item.email }}</span>
              </div>
              <div class="item-actions">
                <span class="status-tag" [class.active]="item.signatureImageId" [class.neutral]="!item.signatureImageId">
                  <span class="status-dot" [class.neutral]="!item.signatureImageId"></span>
                  {{ (item.signatureImageId ? 'dataManagement.organizationSettings.fields.signaturePresent' : 'dataManagement.organizationSettings.fields.noSignature') | transloco }}
                </span>
                <button
                  mat-icon-button
                  color="primary"
                  *ngIf="item.personProfileId > 0"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.editSignature' | transloco"
                  (click)="openSignatureDialog(item)">
                  <mat-icon>draw</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="primary"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.editSignee' | transloco"
                  (click)="editSignee(signees.indexOf(item))">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  [attr.aria-label]="'dataManagement.organizationSettings.aria.deleteSignee' | transloco"
                  (click)="deleteSignee(signees.indexOf(item))">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>

  </mat-card-content>

  <div class="sticky-actions">
    <button mat-button type="button" (click)="cancelChanges()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" [disabled]="!hasChanges() || isSaving" (click)="saveChanges()">
      <mat-icon>save</mat-icon>
      {{ 'common.buttons.save' | transloco }}
    </button>
  </div>
</mat-card>
